import Contentstack from "contentstack";

export const getStack = (hash) => {
  const Stack = Contentstack.Stack({
    api_key: process.env.NEXT_PUBLIC_CONTENTSTACK_DELIVERY_API_KEY,
    delivery_token: process.env.NEXT_PUBLIC_CONTENTSTACK_DELIVERY_TOKEN,
    environment: process.env.NEXT_PUBLIC_CONTENTSTACK_ENVIRONMENT,
    live_preview: {
      enable: Boolean(hash),
      preview_token: process.env.CONTENTSTACK_PREVIEW_TOKEN,
      host: 'rest-preview.contentstack.com',
    },
  });

  if (hash) {
    Stack.livePreviewQuery({ live_preview: hash });
  }

  return Stack;
};

const Stack = Contentstack.Stack({
  api_key: process.env.CONTENTSTACK_DELIVERY_API_KEY,
  delivery_token: process.env.CONTENTSTACK_DELIVERY_TOKEN,
  environment: process.env.CONTENTSTACK_ENVIRONMENT
});

export default Stack;
